/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { InfoDrawer } from 'src/components/EasyRewards';
import { IconDownChevron, IconPlusThin } from 'src/components/Icons';
import Tooltip from 'src/components/Tooltip';
import { Body, Button, Heading } from 'src/components/UI';
import {
    eventMetricsMap,
    useErTooltips,
    useEventsReporter,
    useUserInfo,
} from 'src/hooks';
import { Box } from '@material-ui/core';
import { useUserUpdateContext } from 'src/lib/contexts/user-update-context';
import {
    FavoriteOffersList,
    useFavoriteOffersQuery,
} from 'src/services/easyRewardsServices';
import { mergeClasses } from 'src/stylesheets/utils';
import Row from 'src/components/Row';
import CategoryInfoImg from '../../../assets/InfoTooltipImages/CategoryInfoImg.png';
import ChooseCategoryDrawer from './ChooseCategoryDrawer';
import styles from './styles.module.scss';

interface FavoriteCardProps {
    title: string;
    subtitle: string | null;
    img: string | null;
    onClick: () => void;
}
function FavoriteCard({ title, subtitle, img, onClick }: FavoriteCardProps) {
    return (
        <div className={styles.cardContainer} onClick={onClick}>
            <div className={styles.infoIcon}>
                {/* TODO move this to icons */}
                <img
                    id="onboarding-swipeable-elem-image"
                    src={require('../../../assets/screenshots/infoIcon.svg')}
                    alt="onboarding introduction"
                />
            </div>
            <img className={styles.cardImage} src={img || ''} alt="category" />
            <div className={styles.cardDetailsContainer}>
                <Heading
                    textAlign="textCenter"
                    type="h6"
                    className={styles.title}
                >
                    {title}
                </Heading>
                {subtitle && (
                    <p className={styles.cardSubheading}>{subtitle}</p>
                )}
            </div>
        </div>
    );
}

interface FavoriteCardAddProps {
    onClick: () => void;
}
function FavoriteCardAdd({ onClick }: FavoriteCardAddProps) {
    return (
        <div role="button" onClick={onClick} className={styles.cardContainer}>
            <div className={styles.cardPlusIconContainer}>
                <IconPlusThin />
            </div>
            <div>
                <Heading textAlign="textCenter" type="h6">
                    Add
                </Heading>
                <p className={styles.cardSubheading}>to earn points</p>
            </div>
        </div>
    );
}

interface SelectedOffersProps {
    subscribedList: FavoriteOffersList | undefined;
    isSubscribedOffersListEmpty: boolean;
    setInfoDrawerOpenOffer: (id: string) => void;
    setIsFavoriteSelectionDrawerOpen: (arg: boolean) => void;
}
function SelectedOffers({
    subscribedList,
    isSubscribedOffersListEmpty,
    setInfoDrawerOpenOffer,
    setIsFavoriteSelectionDrawerOpen,
}: SelectedOffersProps) {
    const { analyticsCustomEvent } = useEventsReporter();

    const { userInfo } = useUserInfo();

    return isSubscribedOffersListEmpty ? null : (
        <>
            {new Array(3).fill(null).map((_v, index) => {
                const offer = subscribedList?.[index];
                return offer ? (
                    <FavoriteCard
                        key={offer.id}
                        title={offer.name}
                        subtitle={offer.alternativedescription}
                        img={offer.digitalviewimage}
                        onClick={() => {
                            analyticsCustomEvent(eventMetricsMap.easy_rewards, {
                                click_text: offer.name,
                                element_location:
                                    'Your bonus points categories',
                                event_rewards_number:
                                    userInfo?.rewardsNumber?.padStart(
                                        10,
                                        '0'
                                    ) || '',
                            });
                            setInfoDrawerOpenOffer(offer.id);
                        }}
                    />
                ) : (
                    <FavoriteCardAdd
                        key={index}
                        onClick={() => {
                            analyticsCustomEvent(eventMetricsMap.easy_rewards, {
                                click_text: 'Add',
                                element_location:
                                    'Your bonus points categories',
                                event_rewards_number:
                                    userInfo?.rewardsNumber?.padStart(
                                        10,
                                        '0'
                                    ) || '',
                            });
                            setIsFavoriteSelectionDrawerOpen(true);
                        }}
                    />
                );
            })}
        </>
    );
}

function ManageFavoritesCard() {
    const { showTooltip, setTooltipStatusAsSeen, setShowTooltip } =
        useErTooltips();
    const tooltipRef = useRef(null);
    const emptySubscribeListRef = useRef(null);

    const { analyticsCustomEvent } = useEventsReporter();
    const { isNotifyChooseCategory } = useUserUpdateContext();
    const { userInfo } = useUserInfo();
    const [isFavoriteSelectionDrawerOpen, setIsFavoriteSelectionDrawerOpen] =
        useState<boolean>(false);
    const [expandCategory, setExpandCategory] = useState<boolean>(false);

    // Info drawer state management
    const [infoDrawerState, setInfoDrawerState] = useState<{
        open: boolean;
        selectedOffer: string | null;
    }>({
        open: false,
        selectedOffer: null,
    });
    const toggleInfoDrawerOpen = (isOpen: boolean) =>
        setInfoDrawerState((oldState) => ({ ...oldState, open: isOpen }));

    const setInfoDrawerOpenOffer = (id: string) =>
        setInfoDrawerState({ open: true, selectedOffer: id });

    const { data: offerList, isFetching: isOffersFetching } =
        useFavoriteOffersQuery({
            initialData: [] as unknown as FavoriteOffersList,
        });

    const subscribedList = useMemo(
        () => offerList?.filter((offer) => offer.subscribed),
        [offerList]
    );

    const isSubscribedOffersListEmpty = subscribedList
        ? subscribedList.length === 0
        : false;

    useEffect(() => {
        if (isNotifyChooseCategory) {
            setIsFavoriteSelectionDrawerOpen(true);
        }
    }, [isNotifyChooseCategory]);

    useEffect(() => {
        if (isSubscribedOffersListEmpty && !isOffersFetching) {
            setShowTooltip('categoriesTooltip');
        }
    }, [isSubscribedOffersListEmpty, isOffersFetching]);

    const ImageRender = ({ offer, index }: { offer: any; index: number }) => {
        if (offer?.digitalviewimage) {
            return (
                <img
                    key={index}
                    tabIndex={3 + index}
                    aria-label="Category"
                    className={styles.collapseImgNew}
                    src={offer.digitalviewimage}
                    alt="categoryImg"
                />
            );
        }
        return null;
    };

    return (
        <>
            <Tooltip
                toolTipPlacement="bottom"
                tooltipText="Update your categories as often as you want!"
                elementRef={tooltipRef}
                onClose={() => {
                    setTooltipStatusAsSeen('categoriesTooltip');
                }}
                tooltipImgSrc={CategoryInfoImg}
                showTooltip={showTooltip('categoriesTooltip')}
            >
                <div ref={tooltipRef}>
                    {!isSubscribedOffersListEmpty ? (
                        <>
                            <Box
                                sx={{
                                    mb: '10px',
                                }}
                            >
                                <Row gap="6px">
                                    <>
                                        {[0, 1, 2].map((index) => {
                                            const offer =
                                                subscribedList?.[index];

                                            if (offer) {
                                                return (
                                                    <Box
                                                        onClick={() => {
                                                            setInfoDrawerOpenOffer(
                                                                offer?.id
                                                            );
                                                        }}
                                                    >
                                                        <ImageRender
                                                            key={index}
                                                            offer={offer}
                                                            index={index}
                                                        />
                                                    </Box>
                                                );
                                            }

                                            const shouldShowAddButton =
                                                subscribedList &&
                                                subscribedList.length >= 1;

                                            const handleAddClick = () => {
                                                analyticsCustomEvent(
                                                    eventMetricsMap.easy_rewards,
                                                    {
                                                        click_text: 'Add',
                                                        element_location:
                                                            'Your bonus points categories',
                                                        event_rewards_number:
                                                            userInfo?.rewardsNumber?.padStart(
                                                                10,
                                                                '0'
                                                            ) || '',
                                                    }
                                                );
                                                setIsFavoriteSelectionDrawerOpen(
                                                    true
                                                );
                                            };

                                            const AddButton = (
                                                <Box
                                                    key={`add-${index}`}
                                                    onClick={handleAddClick}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: '40px',
                                                            height: '40px',
                                                            borderRadius: '50%',
                                                            border: '1px dashed #E6E6E6',
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <Body
                                                            size={24}
                                                            weight="bold"
                                                            color="textExtraLightGray"
                                                        >
                                                            {index + 1}
                                                        </Body>
                                                    </Box>
                                                </Box>
                                            );

                                            return shouldShowAddButton
                                                ? AddButton
                                                : null;
                                        })}
                                    </>
                                </Row>
                            </Box>
                            <Box
                                sx={{
                                    mb: '15px',
                                }}
                            >
                                <Row direction="column" gap="4px">
                                    <>
                                        <Body
                                            size={12}
                                            lineHeight={18}
                                            weight="bold"
                                            color="textBlack"
                                            className={styles.textUpperCase}
                                        >
                                            bonus categories
                                        </Body>
                                        {subscribedList &&
                                            subscribedList.length > 0 && (
                                                <Body
                                                    size={12}
                                                    weight="light"
                                                    color="#000000"
                                                    tabIndex={2}
                                                    ariaLabel={`Renews on ${moment(
                                                        subscribedList[0]
                                                            ?.subscriptionenddate
                                                    ).format('MM/DD/YY')}`}
                                                    ariaDescription="Category information and points value may change."
                                                >
                                                    {`Renews on ${moment(
                                                        subscribedList[0]
                                                            ?.subscriptionenddate
                                                    ).format('MM/DD/YY')}`}
                                                </Body>
                                            )}
                                    </>
                                </Row>
                            </Box>
                            <Box
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    analyticsCustomEvent(
                                        eventMetricsMap.easy_rewards,
                                        {
                                            click_text: 'Update',
                                            element_location:
                                                'Your bonus points categories',
                                            event_rewards_number:
                                                userInfo?.rewardsNumber || '',
                                        }
                                    );
                                    setIsFavoriteSelectionDrawerOpen(true);
                                    setTooltipStatusAsSeen('categoriesTooltip');
                                }}
                            >
                                <Body
                                    size={12}
                                    lineHeight={16}
                                    weight="light"
                                    color="textLinkBlue"
                                >
                                    Update categories
                                </Body>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box
                                sx={{
                                    mb: '19px',
                                }}
                            >
                                <Row direction="column" gap="4px">
                                    <>
                                        <Body
                                            size={12}
                                            lineHeight={18}
                                            weight="bold"
                                            color="textBlack"
                                            className={styles.textUpperCase}
                                        >
                                            bonus categories
                                        </Body>
                                        <Box>
                                            <Body
                                                size={12}
                                                weight="light"
                                                color="#000000"
                                                lineHeight={16}
                                            >
                                                Earn double or more
                                            </Body>
                                            <Body
                                                size={12}
                                                weight="light"
                                                color="#000000"
                                                lineHeight={16}
                                            >
                                                points on what you buy
                                            </Body>
                                            <Body
                                                size={12}
                                                weight="light"
                                                color="#000000"
                                                lineHeight={16}
                                            >
                                                most.
                                            </Body>
                                        </Box>
                                    </>
                                </Row>
                            </Box>
                            <Row justifyContent={'center'}>
                                <>
                                    <Box
                                        sx={{
                                            bgcolor: 'white',
                                            border: '1px solid #5B0069',
                                            borderRadius: '100px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '132px',
                                            height: '31px',
                                        }}
                                        onClick={() => {
                                            analyticsCustomEvent(
                                                eventMetricsMap.easy_rewards,
                                                {
                                                    click_text: 'Add',
                                                    element_location:
                                                        'Your bonus points categories',
                                                    event_rewards_number:
                                                        userInfo?.rewardsNumber?.padStart(
                                                            10,
                                                            '0'
                                                        ) || '',
                                                }
                                            );
                                            setIsFavoriteSelectionDrawerOpen(
                                                true
                                            );
                                            setTooltipStatusAsSeen(
                                                'categoriesTooltip'
                                            );
                                        }}
                                    >
                                        <Body color="textPurple" size={12}>
                                            Make a selection
                                        </Body>
                                    </Box>
                                </>
                            </Row>
                            {/* <Button
                                variant="outlined-rounded"
                                borderColor="borderPurple"
                                color="textPurple"
                                bgColor="bgWhite"
                                align="alignSelfStart"
                                className='makeSectionButton'
                                ref={emptySubscribeListRef}
                                onClick={() => {
                                    analyticsCustomEvent(
                                        eventMetricsMap.easy_rewards,
                                        {
                                            click_text: 'Add',
                                            element_location:
                                                'Your bonus points categories',
                                            event_rewards_number:
                                                userInfo?.rewardsNumber?.padStart(
                                                    10,
                                                    '0'
                                                ) || '',
                                        }
                                    );
                                    setIsFavoriteSelectionDrawerOpen(true);
                                    setTooltipStatusAsSeen('categoriesTooltip');
                                }}
                            >
                                Make a selection
                            </Button> */}
                        </>
                    )}
                </div>
            </Tooltip>

            <ChooseCategoryDrawer
                categoryDrawerOpen={isFavoriteSelectionDrawerOpen}
                setIsFavoriteSelectionDrawerOpen={
                    setIsFavoriteSelectionDrawerOpen
                }
            />
            {offerList && offerList.length > 0 && infoDrawerState.open && (
                <InfoDrawer
                    open={infoDrawerState.open}
                    setIsOpen={toggleInfoDrawerOpen}
                    offerList={offerList as FavoriteOffersList}
                    openOfferId={infoDrawerState.selectedOffer}
                />
            )}
        </>
    );
}

export default ManageFavoritesCard;
